import styled, { css, keyframes } from 'styled-components';
import { Colors, FInter, FlexBox, MEDIA } from '@brg/ui';
import { LayoutConst } from '../../../core';
import { PointWrapper } from '../pointBox/PointBox';
import { ItemType } from 'shared/constants/itemType';

export const COVER_VIEWTYPES_1_9 = ['t-shape', 'fixed-ratio-large', 'horizontal', 'animated'];

type FixedRatioLargeCardBreakpoint = keyof typeof LayoutConst.fixedRatioLargeCard;

const projectFromCardSizeStyles = (breakpoint: FixedRatioLargeCardBreakpoint) => {
  const { w, h } = LayoutConst.fixedRatioLargeCard[breakpoint];

  if (breakpoint === 'mobile') {
    const { w, h } = LayoutConst.fixedRatioLargeCard.desktop;

    return css`
      width: 100%;
      max-width: 100%;
      min-width: 0;
      height: auto;
      min-height: unset;
      max-height: none;
      aspect-ratio: ${w} / ${h};
      overflow: hidden;
    `;
  }

  return css`
    width: ${w}px;
    height: ${h}px;
    min-width: ${w}px;
    min-height: ${h}px;
    max-width: ${w}px;
    max-height: ${h}px;
    overflow: hidden;
  `;
};

export const ProjectCardDraftWrapperNew = styled(FlexBox)<{ img: string, noGrid?: boolean, viewType?: string, sizeMult?: number, hasTitle?: boolean, metaAlwaysVisible?: boolean }>`
${({ viewType, sizeMult, img, noGrid, hasTitle, metaAlwaysVisible }) => metaAlwaysVisible ? css`
  .meta {
    opacity: 1 !important;
    transition: none;
  }
` : ''}
${({ viewType, sizeMult, img, noGrid, hasTitle }) => viewType && ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'horizontal', 'animated']?.includes(viewType) ? css`
  position: relative;
  width: 100%;
  max-width: 100%;
  height: ${`${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  grid-column: span 2;

  box-shadow:${viewType === 'fixed-ratio-small' ? '0px 4px 4px 0px rgba(0,0,0,0.12)' : 'none'};

  overflow: hidden;
  padding: 16px 16px 11px;
  transition: all 0.2s;
  cursor: pointer;

  .title-wrapper {
    opacity: ${['fixed-ratio-small']?.includes(viewType) ? '0' : '1'} !important;
  }

  .meta {
    opacity: 0;
    transition: all 0.2s;

    ${['t-shape', 'fixed-ratio-large']?.includes(viewType) && img ? css`
      margin: 16px 0 0 16px;
    ` : null};

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
      margin: 0;
    }
  }
  &:hover .meta {
      opacity: 1;
  }

  @media(max-width: ${LayoutConst.screen.l}px) {
    .meta {
      opacity: 1;
      transition: all 0.2s;
    }
  }

  &:hover {
    .title-wrapper {
      opacity: 1 !important;
    }
  }

  justify-content: space-between;
  flex-direction: column;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: ${LayoutConst.projectCard.l.h + 'px'};
    min-width: ${LayoutConst.projectCard.l.w + 'px'};
    min-height: ${LayoutConst.projectCard.l.h + 'px'};
    max-height: ${LayoutConst.projectCard.l.h + 'px'};
    padding: ${!['t-shape', 'fixed-ratio-large']?.includes(viewType) ? '16px 16px 11px' : !img ? '16px' : '0 0 16px 0'};
  }

  // @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
  //   height: ${LayoutConst.projectCard.m.h + 'px'};
  //   min-width: ${LayoutConst.projectCard.m.w + 'px'};
  //   min-height: ${LayoutConst.projectCard.m.h + 'px'};
  //   max-height: ${LayoutConst.projectCard.m.h + 'px'};
  //   background-size: ${['t-shape', 'fixed-ratio-large']?.includes(viewType) ? `100% ${LayoutConst.projectCard.m.h1_9 + 'px'}` : 'cover' };
  //   padding: ${!['t-shape', 'fixed-ratio-large']?.includes(viewType) ? '16px' : !img ? '16px' : '0 0 16px 0'};
  // }

  @media (max-width: ${LayoutConst.screen.l + 'px'}) {
    height: ${LayoutConst.projectCard.xs.h + 'px'};
    min-width: ${LayoutConst.projectCard.xs.w + 'px'};
    min-height: ${LayoutConst.projectCard.xs.h + 'px'};
    max-height: ${LayoutConst.projectCard.xs.h + 'px'};
    padding: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    width: 100%;
    max-width: 100%;
    height: ${`${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-height: ${`${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    max-height: ${`${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  }

` : css`
  position: relative;
  overflow: hidden;
  width: ${LayoutConst.projectCard.l.w + 'px'};
  height: ${LayoutConst.projectCard.l.h + 'px'};


// @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
//   width: ${LayoutConst.projectCard.m.w + 'px'};
//   height: ${LayoutConst.projectCard.m.h + 'px'};
//   min-width: ${LayoutConst.projectCard.m.w + 'px'};
//   min-height: ${LayoutConst.projectCard.m.h + 'px'};
//   max-width: ${LayoutConst.projectCard.m.w + 'px'};
//   max-height: ${LayoutConst.projectCard.m.h + 'px'};
// }

@media (max-width: ${LayoutConst.screen.l + 'px'}) {
  width: ${LayoutConst.projectCard.xs.w + 'px'};
  height: ${LayoutConst.projectCard.xs.h + 'px'};
  min-width: ${LayoutConst.projectCard.xs.w + 'px'};
  min-height: ${LayoutConst.projectCard.xs.h + 'px'};
  max-width: ${LayoutConst.projectCard.xs.w + 'px'};
  max-height: ${LayoutConst.projectCard.xs.h + 'px'};
}

@media(max-width: ${LayoutConst.screen.s - 1}px) {
  .meta {
    opacity: 1;
    transition: all 0.2s;
  }
}

@media (max-width: ${LayoutConst.screen.s - 1}px) { // На 768px проблема "поехавшего грида сохранялась - 767 Раньше было 940px
  ${() => {
    const width = noGrid ? 100 : 50;
    const padding = noGrid ? 20 : 15;
    return css`
      width: calc(${width}vw - ${padding}px);
      height: calc((${width}vw - ${padding}px) * 1.407);
      max-width: calc(${width}vw - ${padding}px);
      max-height: calc((${width}vw - ${padding}px) * 1.407);
      min-width: calc(${width}vw - ${padding}px);
      min-height: calc((${width}vw - ${padding}px) * 1.407);
    `}
  }
}

transition: all 0.2s;
cursor: pointer;

.meta {
    opacity: 0;
    transition: all 0.2s;
}
&:hover .meta {
    opacity: 1;
}

@media(max-width: ${LayoutConst.screen.s - 1}px) {
  .meta {
    opacity: 1;
    transition: all 0.2s;
  }
}

justify-content: space-between;
flex-direction: column;
padding: 16px 16px 11px;
`};

`;

const DelayZindex = keyframes`
    from {
      z-index: 2;
    }
    to {
      z-index: 3;
    }
`;

const DelayZindexBack = keyframes`
  from {
    z-index: 3;
  }
  to {
    z-index: 2;
  }
`;

//todo Переделать верстку карточек. Совсем.

//Я знаю, что считать размер - это ужасно) Но здесь его иначе не перебить

export const ProjectCardContainerNew = styled(FlexBox)<{
  isLoading?: boolean;
  width?: string;
  height?: string;
  noGrid?: boolean;
  tooltipOpen?: boolean;
  isSquare?: boolean;
  sizeMult?: number;
  isAgeytomesh?: boolean;
  hasBottomText?: boolean;
  viewType?: string;
  itemType?: string;
  cardBgColor?: string;
  isOneColumn?: boolean;
  isPartnerMaterial?: boolean;
  isFtbl?: boolean;
  isProjectFromCard?: boolean;
  isLargeProject?: boolean;
}>`
  z-index: ${({tooltipOpen}) => tooltipOpen ? 3 : 2};
  position: relative;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);

  ${({ cardBgColor }) => cardBgColor && css`
    background-color: ${cardBgColor};
  `};
  
  ${({ isProjectFromCard }) => isProjectFromCard && projectFromCardSizeStyles('desktop')}

  ${({ itemType, sizeMult, viewType, hasBottomText, isProjectFromCard }) => isProjectFromCard ? false : (itemType === ItemType.shortlist && hasBottomText ? css`
    height: 320px;
    min-width: ${LayoutConst.bookCard.l.w}px;
    min-height: 320px;
    max-height: 320px;
  ` : (itemType === ItemType.shortlist || itemType === ItemType.book) ? css`
    height: ${LayoutConst.bookCard.l.h}px;
    min-width: ${LayoutConst.bookCard.l.w}px;
    min-height: ${LayoutConst.bookCard.l.h}px;
    max-height: ${LayoutConst.bookCard.l.h}px;
  ` : css`
    width: 100%;
    max-width: 100%;
    min-width: ${LayoutConst.projectCard.l.w + 'px'};
    //width: ${LayoutConst.projectCard.l.w * (sizeMult || 1) + 'px'};
    height: ${`${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  `)}


  @media ${MEDIA.LAPTOP} {
    ${({ isProjectFromCard }) => isProjectFromCard && projectFromCardSizeStyles('laptop')}
  }

  @media ${MEDIA.TABLET} {
    ${({ isProjectFromCard }) => isProjectFromCard && projectFromCardSizeStyles('tablet')}
  }

  @media ${MEDIA.MOBILE} {
    ${({ isProjectFromCard }) => isProjectFromCard && projectFromCardSizeStyles('mobile')}
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ sizeMult, viewType, itemType, hasBottomText, isProjectFromCard }) => isProjectFromCard ? false : (itemType && !!['book']?.includes(itemType)) ? css`
      height: ${LayoutConst.bookCard.m.h}px;
      min-width: ${LayoutConst.bookCard.m.w}px;
      min-height: ${LayoutConst.bookCard.m.h}px;
      max-height: ${LayoutConst.bookCard.m.h}px;
    ` : itemType === ItemType.competition ? css`
      height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
      min-width: ${LayoutConst.projectCard.tablet.w + 'px'};
      min-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
      max-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    ` : itemType === ItemType.other ? css`
      min-width: ${LayoutConst.bookCard.m.w + 'px'};
      height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;
      max-height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;
      min-height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;
    ` : itemType === ItemType.shortlist && hasBottomText ? css`
      height: ${LayoutConst.bookCard.s.h}px;
      min-height: ${LayoutConst.bookCard.s.h}px;
      max-height: ${LayoutConst.bookCard.s.h}px;
      min-width: ${LayoutConst.bookCard.m.w}px;
    ` : itemType === ItemType.shortlist ? css`
      height: ${LayoutConst.bookCard.m.h}px;
      min-width: ${LayoutConst.bookCard.m.w}px;
      min-height: ${LayoutConst.bookCard.m.h}px;
      max-height: ${LayoutConst.bookCard.m.h}px;
    ` : null}
  }

    @media (max-width: ${LayoutConst.screen.l}px) {

    ${({ sizeMult, viewType, itemType, isProjectFromCard }) => isProjectFromCard ? false : (itemType && !![/*'competition', */'book']?.includes(itemType)) ? css`
    height: ${LayoutConst.bookCard.m.h}px;
    min-width: ${LayoutConst.bookCard.m.w}px;
    min-height: ${LayoutConst.bookCard.m.h}px;
    max-height: ${LayoutConst.bookCard.m.h}px;
    ` : itemType === ItemType.other ? css`
    // width: ${LayoutConst.projectCard.m.w * (sizeMult || 1) + 'px'};

    height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;
    max-height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;
    min-height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;

    // height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.s.w + 'px'};
    // min-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    // max-width: ${ LayoutConst.projectCard.m.w * (sizeMult || 1)}px;
    // max-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}}`}px;
    ` : itemType === ItemType.competition ? css`
    height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.tablet.w + 'px'};
    min-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    max-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    ` : css`
    // width: ${LayoutConst.projectCard.tablet.w * (sizeMult || 1) + 'px'};
    height: ${`${LayoutConst.projectCard.tablet[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.tablet.w + 'px'};
    min-height: ${`${LayoutConst.projectCard.tablet[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    //max-width: ${ LayoutConst.projectCard.tablet.w * (sizeMult || 1)}px;
    max-height: ${`${LayoutConst.projectCard.tablet[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  `}
  }

  @media (max-width: ${LayoutConst.screen.md + 'px'}) {
    ${({ sizeMult, itemType, viewType  }) => itemType && !!['competition']?.includes(itemType) ? css`
    height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.xs.w + 'px'};
    min-height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    max-height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
      ` : itemType && !!['book']?.includes(itemType) ? css`
      // height: ${LayoutConst.bookCard.m.h}px;
      min-width: auto;
      min-height: auto;
      max-height: 100%;
      width: 100%;
      height: auto;
      aspect-ratio: 166 / 235;
      ` : itemType === ItemType.other ? css`
      min-width: ${LayoutConst.projectCard.s.w + 'px'};
  ` : null}

  }

  @media (max-width: ${LayoutConst.screen.l + 'px'}) {
    ${({ viewType, isProjectFromCard }) => !isProjectFromCard && COVER_VIEWTYPES_1_9.includes(viewType ?? '') && css`
      height: ${LayoutConst.mapCard.s['h']}px;
      min-height: ${LayoutConst.mapCard.s['h']}px;
      max-height: ${LayoutConst.mapCard.s['h']}px;
    `
    }
  }


  @media (max-width: ${LayoutConst.screen.s + 'px'}) {
    ${({ sizeMult, viewType, itemType, isProjectFromCard }) => isProjectFromCard ? false : (
      //(
        //     itemType && !![/*'competition',*/ 'book']?.includes(itemType)) ? css`
  //   height: calc((50vw - 15px) * 1.407);
  //   max-height: calc((50vw - 15px) * 1.407);
  //   min-width: calc(50vw - 15px);
  //   min-height: calc((50vw - 15px) * 1.407);
  // ` 
  itemType === ItemType.other ? css`
    height: ${`${LayoutConst.projectCard.xs.h * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.xs.w + 'px'};
    min-height: ${LayoutConst.projectCard.xs.h + 'px'};
    max-height: ${`${LayoutConst.projectCard.xs.h * (sizeMult || 1)}`}px;
  ` : css`
    height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.xs.w + 'px'};
    min-height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    max-height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  `)}
  }

  @media ${MEDIA.MOBILE} { // На 768px проблема "поехавшего грида сохранялась - 767 норм
    ${({ isPartnerMaterial, isProjectFromCard }) => !isProjectFromCard && css`
      // height: calc((50vw - 15px) * 1.407) !important;
      // max-height: calc((50vw - 15px) * 1.407) !important;
      //min-width: calc(50vw - 15px) !important;
      aspect-ratio: 1 / 1.407;
      // min-height: calc((50vw - 15px) * 1.407) !important;
    `
    }
    ${({ noGrid, isSquare, viewType, isOneColumn, isProjectFromCard }) => {
      if (isProjectFromCard) {
        return '';
      }

      const ratio = COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 1 / 1.9 : viewType === 'fixed-ratio-small' ? 1 / 1.48 : 1.407;
      const width = noGrid || ['fixed-ratio-small', 'fixed-ratio-large', 't-shape', 'animated'].includes(String(viewType)) || isOneColumn ? 100 : 50;
      const padding = noGrid ? 20 : 15;
      const calculatedWidth = `calc(${width}vw - ${padding}px)`;
      const calculatedHeight = isSquare ? calculatedWidth : `calc((${width}vw - ${padding}px) * ${ratio})`;

      return css`
        // width: ${calculatedWidth};
        height: ${calculatedHeight};
        // max-width: ${calculatedWidth};
        max-height: ${calculatedHeight};
        // min-width: ${calculatedWidth};
        min-height: ${calculatedHeight};
      `;
    }}
    ${({ itemType, sizeMult, viewType, isProjectFromCard }) => !isProjectFromCard && (itemType && !![ 'other']?.includes(itemType)) && css`
      height: calc((50vw - 15px) * 1.407);
      max-height: calc((50vw - 15px) * 1.407);
      min-width: calc(50vw - 15px);
      min-height: calc((50vw - 15px) * 1.407);
    `};

    ${({ isFtbl }) => isFtbl && css`
      max-height: calc(((100vw - 30px) / 2) * 1.4138);
      min-height: calc(((100vw - 30px) / 2) * 1.4138);
      min-width: calc((100vw - 30px) / 2);
      height: calc(((100vw - 30px) / 2) * 1.4138);
    `};
  }

`;

export const ProjectCardWrapperNew = styled.div<{
  isLoading?: boolean;
  width?: string;
  height?: string;
  tooltipOpen?: boolean;
  viewType?: string;
  isCompetition?: boolean;
  isBookChapter?: boolean;
  backgroundStyles?: any
}>`
  z-index: 2;
  display: flex;
  width: 100%;
  height: 100%;
  transition: all 0.2s;
  position: relative;

  .meta {
    opacity: 0;
    transition: all 0.2s;
  }

  ${({ backgroundStyles }) => backgroundStyles && css`
    ${backgroundStyles}
  `};

  ${(p) =>
    p.isBookChapter
      ? css`
        @media ${MEDIA.LAPTOP} {
          .meta {
            opacity: 1 !important;
          }
        }
      `
      : null}
  

  &:hover {
    cursor: pointer;
    background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.6) 100%);
    background-position: center center;
    background-size: cover;
    .meta {
      opacity: 1;
    }
    .project-badge {
      opacity: 0;
    }
    ${PointWrapper} {
      opacity: 0;
    }
    .alert-block {
      opacity: 1;
    }
  }

    @media ${MEDIA.TABLET} {
      .meta {
        opacity: 1;
      }
    }

  &.meta--visible {
    cursor: pointer;
    background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.6) 100%);
    background-position: center center;
    background-size: cover;
    .meta {
      opacity: 1;
      
    }
    ${PointWrapper} {
      opacity: 0;
    }
    .alert-block {
      opacity: 1;
    }

    @media${MEDIA.MOBILE} {
      background: none;
    }
  }

  justify-content: space-between;
  flex-direction: column;
  padding: 12px 16px 16px 16px;

  @media ${MEDIA.LAPTOP} {
    padding: ${({ isLoading }) => isLoading ? '0' : '10px 12px 16px 12px' };
  }

 ${(p) =>
    p.isLoading && !p.isCompetition
      ? css`
          background: ${(p) => p.theme.skeleton.skeletonBgColor};
          padding: 0;

          &:hover {
            background: ${(p) => p.theme.skeleton.skeletonBgColor};
          }
          .meta {
            opacity: 1 !important;
          }
        `
      : p.isLoading && p.isCompetition
      ? css`
          padding: 0;

         &:hover {
            background: ${(p) => p.theme.skeleton.skeletonBgColor};
          }
          .meta {
            opacity: 1 !important;
          }
        `
      : null}

  @media (max-width: ${LayoutConst.screen.l}px) {
    .meta {
      opacity: 1;
      transition: all 0.2s;
    }
  }
  
`;

export const ProjectCardWrapperDoubleNew = styled(FlexBox)<{ isLoading?: boolean }>`
    z-index: 2;
    width: ${LayoutConst.projectCard.l.w + 'px'};
    height: ${LayoutConst.projectCard.l.h + 'px'};

    @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        width: ${LayoutConst.projectCard.s.w + 'px'};
        height: ${LayoutConst.projectCard.s.h + 'px'};
        min-width: ${LayoutConst.projectCard.s.w + 'px'};
        min-height: ${LayoutConst.projectCard.s.h + 'px'};
        max-width: ${LayoutConst.projectCard.s.w + 'px'};
        max-height: ${LayoutConst.projectCard.s.h + 'px'};
    }

    @media (min-width: ${LayoutConst.screen.l}px) {
        width: ${LayoutConst.projectCard.m.w + 'px'};
        height: ${LayoutConst.projectCard.m.h + 'px'};
        min-width: ${LayoutConst.projectCard.m.w + 'px'};
        min-height: ${LayoutConst.projectCard.m.h + 'px'};
        max-width: ${LayoutConst.projectCard.m.w + 'px'};
        max-height: ${LayoutConst.projectCard.m.h + 'px'};
    }

    // @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
    //     width: ${LayoutConst.projectCard.l.w + 'px'};
    //     height: ${LayoutConst.projectCard.l.h + 'px'};
    //     min-width: ${LayoutConst.projectCard.l.w + 'px'};
    //     min-height: ${LayoutConst.projectCard.l.h + 'px'};
    //     max-width: ${LayoutConst.projectCard.l.w + 'px'};
    //     max-height: ${LayoutConst.projectCard.l.h + 'px'};
    // }
    transition: all 0.2s;
    .meta {
        opacity: 0;
        transition: all 0.2s;
    }
  
    &:hover {
        cursor: pointer;
        background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.73) 100%);
        background-position: center center;
        background-size: cover;
        ${PointWrapper} {
          opacity: 0;
        }
        .meta {
            opacity: 1;
        }
    }

    &.meta--visible {
        cursor: pointer;
        background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.73) 100%);
        background-position: center center;
        background-size: cover;
        ${PointWrapper} {
          opacity: 0;
        }
        .meta {
            opacity: 1;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        // .meta {
        //     opacity: 1;
        //     transition: all 0.2s;
        // }
    }

    ${(p) =>
        p.isLoading
            ? css`
                  background: rgba(255, 255, 255, 0.02) !important;
                  .meta {
                      opacity: 1 !important;
                  }
              `
            : null}

    justify-content: space-between;
    flex-direction: column;
    padding: 16px 16px 11px;

    @media (max-width: 940px) {
        width: calc(50vw - 24px);
        height: calc((50vw - 24px) * 1.407);
        max-width: calc(50vw - 24px);
        max-height: calc((50 - 24px) * 1.407);
        min-width: calc(50vw - 24px);
        min-height: calc((50vw - 24px) * 1.407);
    }
`;

export const ProjectCardTitleNew = styled(FInter.TextBoldDiv)`
    color: ${Colors.geoWhite100};
    word-break: break-word;
`;
import styled, { css, keyframes } from 'styled-components';
import { Colors, FInter, FlexBox, MEDIA } from '@brg/ui';
import { LayoutConst } from '../../../core';
import { PointWrapper } from '../pointBox/PointBox';
import { ItemType } from 'shared/constants/itemType';

export const COVER_VIEWTYPES_1_9 = ['t-shape', 'fixed-ratio-large', 'horizontal', 'animated'];

type FixedRatioLargeCardBreakpoint = keyof typeof LayoutConst.fixedRatioLargeCard;

const projectFromCardSizeStyles = (breakpoint: FixedRatioLargeCardBreakpoint) => {
  const { w, h } = LayoutConst.fixedRatioLargeCard[breakpoint];

  if (breakpoint === 'mobile') {
    const { w, h } = LayoutConst.fixedRatioLargeCard.desktop;

    return css`
      width: 100%;
      max-width: 100%;
      min-width: 0;
      height: auto;
      min-height: unset;
      max-height: none;
      aspect-ratio: ${w} / ${h};
      overflow: hidden;
    `;
  }

  return css`
    width: ${w}px;
    height: ${h}px;
    min-width: ${w}px;
    min-height: ${h}px;
    max-width: ${w}px;
    max-height: ${h}px;
    overflow: hidden;
  `;
};

export const ProjectCardDraftWrapperNew = styled(FlexBox)<{ img: string, noGrid?: boolean, viewType?: string, sizeMult?: number, hasTitle?: boolean, metaAlwaysVisible?: boolean }>`
${({ viewType, sizeMult, img, noGrid, hasTitle, metaAlwaysVisible }) => metaAlwaysVisible ? css`
  .meta {
    opacity: 1 !important;
    transition: none;
  }
` : ''}
${({ viewType, sizeMult, img, noGrid, hasTitle }) => viewType && ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'horizontal', 'animated']?.includes(viewType) ? css`
  position: relative;
  width: 100%;
  max-width: 100%;
  height: ${`${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  grid-column: span 2;

  box-shadow:${viewType === 'fixed-ratio-small' ? '0px 4px 4px 0px rgba(0,0,0,0.12)' : 'none'};

  overflow: hidden;
  padding: 16px 16px 11px;
  transition: all 0.2s;
  cursor: pointer;

  .title-wrapper {
    opacity: ${['fixed-ratio-small']?.includes(viewType) ? '0' : '1'} !important;
  }

  .meta {
    opacity: 0;
    transition: all 0.2s;

    ${['t-shape', 'fixed-ratio-large']?.includes(viewType) && img ? css`
      margin: 16px 0 0 16px;
    ` : null};

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
      margin: 0;
    }
  }
  &:hover .meta {
      opacity: 1;
  }

  @media(max-width: ${LayoutConst.screen.l}px) {
    .meta {
      opacity: 1;
      transition: all 0.2s;
    }
  }

  &:hover {
    .title-wrapper {
      opacity: 1 !important;
    }
  }

  justify-content: space-between;
  flex-direction: column;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: ${LayoutConst.projectCard.l.h + 'px'};
    min-width: ${LayoutConst.projectCard.l.w + 'px'};
    min-height: ${LayoutConst.projectCard.l.h + 'px'};
    max-height: ${LayoutConst.projectCard.l.h + 'px'};
    padding: ${!['t-shape', 'fixed-ratio-large']?.includes(viewType) ? '16px 16px 11px' : !img ? '16px' : '0 0 16px 0'};
  }

  // @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
  //   height: ${LayoutConst.projectCard.m.h + 'px'};
  //   min-width: ${LayoutConst.projectCard.m.w + 'px'};
  //   min-height: ${LayoutConst.projectCard.m.h + 'px'};
  //   max-height: ${LayoutConst.projectCard.m.h + 'px'};
  //   background-size: ${['t-shape', 'fixed-ratio-large']?.includes(viewType) ? `100% ${LayoutConst.projectCard.m.h1_9 + 'px'}` : 'cover' };
  //   padding: ${!['t-shape', 'fixed-ratio-large']?.includes(viewType) ? '16px' : !img ? '16px' : '0 0 16px 0'};
  // }

  @media (max-width: ${LayoutConst.screen.l + 'px'}) {
    height: ${LayoutConst.projectCard.xs.h + 'px'};
    min-width: ${LayoutConst.projectCard.xs.w + 'px'};
    min-height: ${LayoutConst.projectCard.xs.h + 'px'};
    max-height: ${LayoutConst.projectCard.xs.h + 'px'};
    padding: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    width: 100%;
    max-width: 100%;
    height: ${`${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-height: ${`${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    max-height: ${`${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  }

` : css`
  position: relative;
  overflow: hidden;
  width: ${LayoutConst.projectCard.l.w + 'px'};
  height: ${LayoutConst.projectCard.l.h + 'px'};


// @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
//   width: ${LayoutConst.projectCard.m.w + 'px'};
//   height: ${LayoutConst.projectCard.m.h + 'px'};
//   min-width: ${LayoutConst.projectCard.m.w + 'px'};
//   min-height: ${LayoutConst.projectCard.m.h + 'px'};
//   max-width: ${LayoutConst.projectCard.m.w + 'px'};
//   max-height: ${LayoutConst.projectCard.m.h + 'px'};
// }

@media (max-width: ${LayoutConst.screen.l + 'px'}) {
  width: ${LayoutConst.projectCard.xs.w + 'px'};
  height: ${LayoutConst.projectCard.xs.h + 'px'};
  min-width: ${LayoutConst.projectCard.xs.w + 'px'};
  min-height: ${LayoutConst.projectCard.xs.h + 'px'};
  max-width: ${LayoutConst.projectCard.xs.w + 'px'};
  max-height: ${LayoutConst.projectCard.xs.h + 'px'};
}

@media(max-width: ${LayoutConst.screen.s - 1}px) {
  .meta {
    opacity: 1;
    transition: all 0.2s;
  }
}

@media (max-width: ${LayoutConst.screen.s - 1}px) { // На 768px проблема "поехавшего грида сохранялась - 767 Раньше было 940px
  ${() => {
    const width = noGrid ? 100 : 50;
    const padding = noGrid ? 20 : 15;
    return css`
      width: calc(${width}vw - ${padding}px);
      height: calc((${width}vw - ${padding}px) * 1.407);
      max-width: calc(${width}vw - ${padding}px);
      max-height: calc((${width}vw - ${padding}px) * 1.407);
      min-width: calc(${width}vw - ${padding}px);
      min-height: calc((${width}vw - ${padding}px) * 1.407);
    `}
  }
}

transition: all 0.2s;
cursor: pointer;

.meta {
    opacity: 0;
    transition: all 0.2s;
}
&:hover .meta {
    opacity: 1;
}

@media(max-width: ${LayoutConst.screen.s - 1}px) {
  .meta {
    opacity: 1;
    transition: all 0.2s;
  }
}

justify-content: space-between;
flex-direction: column;
padding: 16px 16px 11px;
`};

`;

const DelayZindex = keyframes`
    from {
      z-index: 2;
    }
    to {
      z-index: 3;
    }
`;

const DelayZindexBack = keyframes`
  from {
    z-index: 3;
  }
  to {
    z-index: 2;
  }
`;

//todo Переделать верстку карточек. Совсем.

//Я знаю, что считать размер - это ужасно) Но здесь его иначе не перебить

export const ProjectCardContainerNew = styled(FlexBox)<{
  isLoading?: boolean;
  width?: string;
  height?: string;
  noGrid?: boolean;
  tooltipOpen?: boolean;
  isSquare?: boolean;
  sizeMult?: number;
  isAgeytomesh?: boolean;
  hasBottomText?: boolean;
  viewType?: string;
  itemType?: string;
  cardBgColor?: string;
  isOneColumn?: boolean;
  isPartnerMaterial?: boolean;
  isFtbl?: boolean;
  isProjectFromCard?: boolean;
  isLargeProject?: boolean;
}>`
  z-index: ${({tooltipOpen}) => tooltipOpen ? 3 : 2};
  position: relative;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);

  ${({ cardBgColor }) => cardBgColor && css`
    background-color: ${cardBgColor};
  `};
  
  ${({ isProjectFromCard }) => isProjectFromCard && projectFromCardSizeStyles('desktop')}

  ${({ itemType, sizeMult, viewType, hasBottomText, isProjectFromCard }) => isProjectFromCard ? false : (itemType === ItemType.shortlist && hasBottomText ? css`
    height: 320px;
    min-width: ${LayoutConst.bookCard.l.w}px;
    min-height: 320px;
    max-height: 320px;
  ` : (itemType === ItemType.shortlist || itemType === ItemType.book) ? css`
    height: ${LayoutConst.bookCard.l.h}px;
    min-width: ${LayoutConst.bookCard.l.w}px;
    min-height: ${LayoutConst.bookCard.l.h}px;
    max-height: ${LayoutConst.bookCard.l.h}px;
  ` : css`
    width: 100%;
    max-width: 100%;
    min-width: ${LayoutConst.projectCard.l.w + 'px'};
    //width: ${LayoutConst.projectCard.l.w * (sizeMult || 1) + 'px'};
    height: ${`${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  `)}


  @media ${MEDIA.LAPTOP} {
    ${({ isProjectFromCard }) => isProjectFromCard && projectFromCardSizeStyles('laptop')}
  }

  @media ${MEDIA.TABLET} {
    ${({ isProjectFromCard }) => isProjectFromCard && projectFromCardSizeStyles('tablet')}
  }

  @media ${MEDIA.MOBILE} {
    ${({ isProjectFromCard }) => isProjectFromCard && projectFromCardSizeStyles('mobile')}
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ sizeMult, viewType, itemType, hasBottomText, isProjectFromCard }) => isProjectFromCard ? false : (itemType && !!['book']?.includes(itemType)) ? css`
      height: ${LayoutConst.bookCard.m.h}px;
      min-width: ${LayoutConst.bookCard.m.w}px;
      min-height: ${LayoutConst.bookCard.m.h}px;
      max-height: ${LayoutConst.bookCard.m.h}px;
    ` : itemType === ItemType.competition ? css`
      height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
      min-width: ${LayoutConst.projectCard.tablet.w + 'px'};
      min-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
      max-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    ` : itemType === ItemType.other ? css`
      min-width: ${LayoutConst.bookCard.m.w + 'px'};
      height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;
      max-height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;
      min-height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;
    ` : itemType === ItemType.shortlist && hasBottomText ? css`
      height: ${LayoutConst.bookCard.s.h}px;
      min-height: ${LayoutConst.bookCard.s.h}px;
      max-height: ${LayoutConst.bookCard.s.h}px;
      min-width: ${LayoutConst.bookCard.m.w}px;
    ` : itemType === ItemType.shortlist ? css`
      height: ${LayoutConst.bookCard.m.h}px;
      min-width: ${LayoutConst.bookCard.m.w}px;
      min-height: ${LayoutConst.bookCard.m.h}px;
      max-height: ${LayoutConst.bookCard.m.h}px;
    ` : null}
  }

    @media (max-width: ${LayoutConst.screen.l}px) {

    ${({ sizeMult, viewType, itemType, isProjectFromCard }) => isProjectFromCard ? false : (itemType && !![/*'competition', */'book']?.includes(itemType)) ? css`
    height: ${LayoutConst.bookCard.m.h}px;
    min-width: ${LayoutConst.bookCard.m.w}px;
    min-height: ${LayoutConst.bookCard.m.h}px;
    max-height: ${LayoutConst.bookCard.m.h}px;
    ` : itemType === ItemType.other ? css`
    // width: ${LayoutConst.projectCard.m.w * (sizeMult || 1) + 'px'};

    height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;
    max-height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;
    min-height: ${COVER_VIEWTYPES_1_9.includes(String(viewType))? LayoutConst.projectCard.m.h1_9 * (sizeMult || 1) : LayoutConst.bookCard.m.h}px;

    // height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.s.w + 'px'};
    // min-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    // max-width: ${ LayoutConst.projectCard.m.w * (sizeMult || 1)}px;
    // max-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}}`}px;
    ` : itemType === ItemType.competition ? css`
    height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.tablet.w + 'px'};
    min-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    max-height: ${`${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    ` : css`
    // width: ${LayoutConst.projectCard.tablet.w * (sizeMult || 1) + 'px'};
    height: ${`${LayoutConst.projectCard.tablet[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.tablet.w + 'px'};
    min-height: ${`${LayoutConst.projectCard.tablet[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    //max-width: ${ LayoutConst.projectCard.tablet.w * (sizeMult || 1)}px;
    max-height: ${`${LayoutConst.projectCard.tablet[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  `}
  }

  @media (max-width: ${LayoutConst.screen.md + 'px'}) {
    ${({ sizeMult, itemType, viewType  }) => itemType && !!['competition']?.includes(itemType) ? css`
    height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.xs.w + 'px'};
    min-height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    max-height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
      ` : itemType && !!['book']?.includes(itemType) ? css`
      // height: ${LayoutConst.bookCard.m.h}px;
      min-width: auto;
      min-height: auto;
      max-height: 100%;
      width: 100%;
      height: auto;
      aspect-ratio: 166 / 235;
      ` : itemType === ItemType.other ? css`
      min-width: ${LayoutConst.projectCard.s.w + 'px'};
  ` : null}

  }

  @media (max-width: ${LayoutConst.screen.l + 'px'}) {
    ${({ viewType, isProjectFromCard }) => !isProjectFromCard && COVER_VIEWTYPES_1_9.includes(viewType ?? '') && css`
      height: ${LayoutConst.mapCard.s['h']}px;
      min-height: ${LayoutConst.mapCard.s['h']}px;
      max-height: ${LayoutConst.mapCard.s['h']}px;
    `
    }
  }


  @media (max-width: ${LayoutConst.screen.s + 'px'}) {
    ${({ sizeMult, viewType, itemType, isProjectFromCard }) => isProjectFromCard ? false : (
      //(
        //     itemType && !![/*'competition',*/ 'book']?.includes(itemType)) ? css`
  //   height: calc((50vw - 15px) * 1.407);
  //   max-height: calc((50vw - 15px) * 1.407);
  //   min-width: calc(50vw - 15px);
  //   min-height: calc((50vw - 15px) * 1.407);
  // ` 
  itemType === ItemType.other ? css`
    height: ${`${LayoutConst.projectCard.xs.h * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.xs.w + 'px'};
    min-height: ${LayoutConst.projectCard.xs.h + 'px'};
    max-height: ${`${LayoutConst.projectCard.xs.h * (sizeMult || 1)}`}px;
  ` : css`
    height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.xs.w + 'px'};
    min-height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    max-height: ${`${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  `)}
  }

  @media ${MEDIA.MOBILE} { // На 768px проблема "поехавшего грида сохранялась - 767 норм
    ${({ isPartnerMaterial, isProjectFromCard }) => !isProjectFromCard && css`
      // height: calc((50vw - 15px) * 1.407) !important;
      // max-height: calc((50vw - 15px) * 1.407) !important;
      //min-width: calc(50vw - 15px) !important;
      aspect-ratio: 1 / 1.407;
      // min-height: calc((50vw - 15px) * 1.407) !important;
    `
    }
    ${({ noGrid, isSquare, viewType, isOneColumn, isProjectFromCard }) => {
      if (isProjectFromCard) {
        return '';
      }

      const ratio = COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 1 / 1.9 : viewType === 'fixed-ratio-small' ? 1 / 1.48 : 1.407;
      const width = noGrid || ['fixed-ratio-small', 'fixed-ratio-large', 't-shape', 'animated'].includes(String(viewType)) || isOneColumn ? 100 : 50;
      const padding = noGrid ? 20 : 15;
      const calculatedWidth = `calc(${width}vw - ${padding}px)`;
      const calculatedHeight = isSquare ? calculatedWidth : `calc((${width}vw - ${padding}px) * ${ratio})`;

      return css`
        // width: ${calculatedWidth};
        height: ${calculatedHeight};
        // max-width: ${calculatedWidth};
        max-height: ${calculatedHeight};
        // min-width: ${calculatedWidth};
        min-height: ${calculatedHeight};
      `;
    }}
    ${({ itemType, sizeMult, viewType, isProjectFromCard }) => !isProjectFromCard && (itemType && !![ 'other']?.includes(itemType)) && css`
      height: calc((50vw - 15px) * 1.407);
      max-height: calc((50vw - 15px) * 1.407);
      min-width: calc(50vw - 15px);
      min-height: calc((50vw - 15px) * 1.407);
    `};

    ${({ isFtbl }) => isFtbl && css`
      max-height: calc(((100vw - 30px) / 2) * 1.4138);
      min-height: calc(((100vw - 30px) / 2) * 1.4138);
      min-width: calc((100vw - 30px) / 2);
      height: calc(((100vw - 30px) / 2) * 1.4138);
    `};
  }

`;

export const ProjectCardWrapperNew = styled.div<{
  isLoading?: boolean;
  width?: string;
  height?: string;
  tooltipOpen?: boolean;
  viewType?: string;
  isCompetition?: boolean;
  isBookChapter?: boolean;
  backgroundStyles?: any
}>`
  z-index: 2;
  display: flex;
  width: 100%;
  height: 100%;
  transition: all 0.2s;
  position: relative;

  .meta {
    opacity: 0;
    transition: all 0.2s;
  }

  ${({ backgroundStyles }) => backgroundStyles && css`
    ${backgroundStyles}
  `};

  ${(p) =>
    p.isBookChapter
      ? css`
        @media ${MEDIA.LAPTOP} {
          .meta {
            opacity: 1 !important;
          }
        }
      `
      : null}
  

  &:hover {
    cursor: pointer;
    background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.6) 100%);
    background-position: center center;
    background-size: cover;
    .meta {
      opacity: 1;
    }
    .project-badge {
      opacity: 0;
    }
    ${PointWrapper} {
      opacity: 0;
    }
    .alert-block {
      opacity: 1;
    }
  }

    @media ${MEDIA.TABLET} {
      .meta {
        opacity: 1;
      }
    }

  &.meta--visible {
    cursor: pointer;
    background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.6) 100%);
    background-position: center center;
    background-size: cover;
    .meta {
      opacity: 1;
      
    }
    ${PointWrapper} {
      opacity: 0;
    }
    .alert-block {
      opacity: 1;
    }

    @media${MEDIA.MOBILE} {
      background: none;
    }
  }

  justify-content: space-between;
  flex-direction: column;
  padding: 12px 16px 16px 16px;

  @media ${MEDIA.LAPTOP} {
    padding: ${({ isLoading }) => isLoading ? '0' : '10px 12px 16px 12px' };
  }

 ${(p) =>
    p.isLoading && !p.isCompetition
      ? css`
          background: ${(p) => p.theme.skeleton.skeletonBgColor};
          padding: 0;

          &:hover {
            background: ${(p) => p.theme.skeleton.skeletonBgColor};
          }
          .meta {
            opacity: 1 !important;
          }
        `
      : p.isLoading && p.isCompetition
      ? css`
          padding: 0;

         &:hover {
            background: ${(p) => p.theme.skeleton.skeletonBgColor};
          }
          .meta {
            opacity: 1 !important;
          }
        `
      : null}

  @media (max-width: ${LayoutConst.screen.l}px) {
    .meta {
      opacity: 1;
      transition: all 0.2s;
    }
  }
  
`;

export const ProjectCardWrapperDoubleNew = styled(FlexBox)<{ isLoading?: boolean }>`
    z-index: 2;
    width: ${LayoutConst.projectCard.l.w + 'px'};
    height: ${LayoutConst.projectCard.l.h + 'px'};

    @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        width: ${LayoutConst.projectCard.s.w + 'px'};
        height: ${LayoutConst.projectCard.s.h + 'px'};
        min-width: ${LayoutConst.projectCard.s.w + 'px'};
        min-height: ${LayoutConst.projectCard.s.h + 'px'};
        max-width: ${LayoutConst.projectCard.s.w + 'px'};
        max-height: ${LayoutConst.projectCard.s.h + 'px'};
    }

    @media (min-width: ${LayoutConst.screen.l}px) {
        width: ${LayoutConst.projectCard.m.w + 'px'};
        height: ${LayoutConst.projectCard.m.h + 'px'};
        min-width: ${LayoutConst.projectCard.m.w + 'px'};
        min-height: ${LayoutConst.projectCard.m.h + 'px'};
        max-width: ${LayoutConst.projectCard.m.w + 'px'};
        max-height: ${LayoutConst.projectCard.m.h + 'px'};
    }

    // @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
    //     width: ${LayoutConst.projectCard.l.w + 'px'};
    //     height: ${LayoutConst.projectCard.l.h + 'px'};
    //     min-width: ${LayoutConst.projectCard.l.w + 'px'};
    //     min-height: ${LayoutConst.projectCard.l.h + 'px'};
    //     max-width: ${LayoutConst.projectCard.l.w + 'px'};
    //     max-height: ${LayoutConst.projectCard.l.h + 'px'};
    // }
    transition: all 0.2s;
    .meta {
        opacity: 0;
        transition: all 0.2s;
    }
  
    &:hover {
        cursor: pointer;
        background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.73) 100%);
        background-position: center center;
        background-size: cover;
        ${PointWrapper} {
          opacity: 0;
        }
        .meta {
            opacity: 1;
        }
    }

    &.meta--visible {
        cursor: pointer;
        background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.73) 100%);
        background-position: center center;
        background-size: cover;
        ${PointWrapper} {
          opacity: 0;
        }
        .meta {
            opacity: 1;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        // .meta {
        //     opacity: 1;
        //     transition: all 0.2s;
        // }
    }

    ${(p) =>
        p.isLoading
            ? css`
                  background: rgba(255, 255, 255, 0.02) !important;
                  .meta {
                      opacity: 1 !important;
                  }
              `
            : null}

    justify-content: space-between;
    flex-direction: column;
    padding: 16px 16px 11px;

    @media (max-width: 940px) {
        width: calc(50vw - 24px);
        height: calc((50vw - 24px) * 1.407);
        max-width: calc(50vw - 24px);
        max-height: calc((50 - 24px) * 1.407);
        min-width: calc(50vw - 24px);
        min-height: calc((50vw - 24px) * 1.407);
    }
`;

export const ProjectCardTitleNew = styled(FInter.TextBoldDiv)`
    color: ${Colors.geoWhite100};
    word-break: break-word;
`;
